<div class="hero-container">
    <!-- Left Side: Text Content -->
    <div class="hero-content">
      <div class="trial-label">
       <!-- BETA VERSION -->
      </div>
       <h1>
          @if(header) {
            {{header}}
            <br>
          } 
          @if(primaryHeader){
            <span class="content-primary">{{primaryHeader}}</span>
            <br>
          }
          <span class="content-highlight">{{highlightHeader}}</span>
       </h1>
      <p class="description">
        {{description}}
      </p>
      <div class="button-group">
        <!-- Angular Material Buttons -->
        <button mat-raised-button color="primary" (click)="login()">
          Login
        </button>
      </div>
      <div class="learn-more">
        <!-- <a href="https://www.neso.energy/industry-information/balancing-services/demand-flexibility-service/demand-flexibility-service-explained" target="_blank" rel="noopener noreferrer">
          Learn More
        </a>
        <span class="separator">or</span>
        <a href="/faq" target="_blank" rel="noopener noreferrer">
          FAQs
        </a> -->

        <!-- This service is currently available to selected <a href="https://apps.perse.io" target="_blank">Appsmith</a> customers only.
        If you are interested in using this service, please contact us at
        <a href="mailto:contact@perse.energy">contact&#64;perse.energy</a> -->
      </div>
    </div>
  
    <!-- Right Side: 3D Illustration or Image -->
    <div class="hero-image">
      <!-- Replace with your own image or 3D illustration -->
      <!-- <img
        src="output.png"
        alt="3D Illustration showcasing product"
      /> -->
    </div>
  </div>
  